import { Injectable } from "@angular/core";

import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "@api/common/api-endpoints";
import {
  CreateOfflineTenantVoucherDto,
  FindOfflineTenantVoucherDto,
  OfflineTenantVoucherDto,
  OfflineTenantVoucherStatsDto,
  PageResultDto,
  UpdateOfflineTenantVoucherDto,
} from "@api/dto";

@Injectable()
export class OfflineTenantVoucherService {
  constructor(private httpService: HttpService) {}

  async find(findOfflineTenantVoucherDto: FindOfflineTenantVoucherDto) {
    return await this.httpService.get<PageResultDto<OfflineTenantVoucherDto>>(
      ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER,
      findOfflineTenantVoucherDto
    );
  }

  async create(createOfflineTenantVoucherDto: CreateOfflineTenantVoucherDto) {
    return await this.httpService.post<OfflineTenantVoucherDto>(
      ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER,
      createOfflineTenantVoucherDto
    );
  }

  async findOne(id: string) {
    return await this.httpService.get<OfflineTenantVoucherDto>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/${id}`
    );
  }

  async update(
    id: string,
    updateOfflineTenantVoucherDto: UpdateOfflineTenantVoucherDto
  ) {
    return await this.httpService.put<boolean>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/${id}`,
      updateOfflineTenantVoucherDto
    );
  }

  async delete(id: string) {
    return await this.httpService.delete<boolean>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/${id}`
    );
  }

  async approve(id: string) {
    return await this.httpService.patch<boolean>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/${id}/approve`,
      {}
    );
  }

  async reject(id: string, rejectionReason: string) {
    return await this.httpService.patch<boolean>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/${id}/reject`,
      { rejectionReason }
    );
  }

  async getStats(filters?: any) {
    return await this.httpService.get<OfflineTenantVoucherStatsDto>(
      ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER_STATS,
      filters
    );
  }

  async validateImportCodes(fileId: string, voucherId?: string) {
    if (!fileId?.trim()) {
      throw new Error("Invalid fileId provided");
    }

    // Only validate voucherId if it's provided
    if (voucherId !== undefined && !voucherId?.trim()) {
      throw new Error("Invalid voucherId provided");
    }

    return await this.httpService.post<any>(
      `${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER}/validate-import-codes`,
      { fileId, voucherId }
    );
  }
}
